import { render, staticRenderFns } from "./HospitalRate.vue?vue&type=template&id=675bea67"
import script from "./HospitalRate.vue?vue&type=script&lang=js"
export * from "./HospitalRate.vue?vue&type=script&lang=js"
import style0 from "./HospitalRate.vue?vue&type=style&index=0&id=675bea67&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports